import * as React from 'react';
import { useMemo, useState } from 'react';
import { Search } from '@weddingspot/ws-api-client';
import { FeatureFlagContext, toUSD } from '@weddingspot/ws-core-components';
import { AddToShoppingCartButton, CartItem, ShoppingCartContext } from '@weddingspot/ws-core-components';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';

import { Button } from '@cvent/carina/components/Button';
const discountIcon = require('../../../assets/icons/discount.svg');

const _styles = require('../venueCard.scss');

interface CardBottomRowProps {
    venue: Search.SearchResult;
    contactAvailable: boolean;
    handlePriceVenueClick: (e: React.SyntheticEvent) => void;
}

const CardBottomRow = (props: CardBottomRowProps) => {
    const { venue, contactAvailable, handlePriceVenueClick } = props;
    const { items, removeItem, addItem } = React.useContext(ShoppingCartContext);
    const { flagEnabled } = React.useContext(FeatureFlagContext);

    const addVenue = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        const value = {
            id: venue.id,
            name: venue.name,
            location: `${venue.city}, ${venue.state_abbr}`,
            imageUrl: venue.images[0] + '?unique=true',
            lastUpdated: new Date().getTime(),
            market: venue.market,
        };
        addItem(value);
        logEvent(AnalyticsEvent.EVTNM_VENUE_ADDED_TO_CART, { source: 'SRP' });
    };
    const removeVenue = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        removeItem(venue.id);
        logEvent(AnalyticsEvent.EVTNM_CLICKED_REMOVE_FROM_LIST_CTA, { source: 'SRP' });
    };

    const isInCart = useMemo(() => {
        return Boolean(items.find((item: CartItem) => item.id === venue.id));
    }, [venue, items]);

    const [cartButtonHover, setCartButtonHover] = useState<boolean>(false);

    const CTAClickHandler = (e: React.SyntheticEvent) => {
        if (contactAvailable) {
            logEvent(AnalyticsEvent.EVTNM_CLICKED_CONTACT_CTA, { source: 'Wedding venues SRP' });
        }
        handlePriceVenueClick(e);
    };

    const showOnlySelectButton = flagEnabled('only_show_select_venue_on_srp');

    return (
        <div className={_styles.cartBottom}>
            <div className={`${_styles.priceAndCapacity} ${_styles.priceAndCapacityNoMargin}`}>
                {venue.discounts_available && <img className={_styles.discountIcon} src={discountIcon} alt='discount available' />}
                {!venue.hide_wedding_costs && !!venue.starting_at && !!venue.max_capacity && (
                    <div className={`${_styles.budgetRange} ${_styles.budgetRangeFull}`} itemProp='priceRange'>
                        Starting at <b>{toUSD(venue.starting_at)}</b> for <b>{venue.max_capacity}</b> Guests
                    </div>
                )}
            </div>
            <div className={_styles.buttonsRow}>
                {!showOnlySelectButton ? (
                    <Button text={contactAvailable ? 'Contact Venue' : venue.cta_button.label} onClick={CTAClickHandler} size='l' />
                ) : venue.cta_button.label === 'Price venue' ? (
                    <Button text={venue.cta_button.label} onClick={CTAClickHandler} size='l' />
                ) : (
                    <div />
                )}
                <AddToShoppingCartButton isInCart={isInCart} removeVenue={removeVenue} addVenue={addVenue} />
            </div>
        </div>
    );
};

export default CardBottomRow;
